export default __webpack_public_path__ + "static/lifestyle_1_mobile-212c6102a19e6204b651f81ca75b3607.png";